<template>
  <div class="fb-eoc-medications-v1">
    <div v-if="showType == 'form-builder'" :style="properties.style">
      <b-form-group
        :description="
          superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'description',
            value: properties.description,
            defaultValue: '',
            form: this.form
          })
        "
        :label="
          superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'label',
            value: properties.label,
            defaultValue: '',
            form: this.form
          })
        "
        :style="properties.style"
      >
        <fb-table-v1
          :showType="showType"
          :properties="tableProperties"
          :id="id"
          :form="form"
        ></fb-table-v1>
      </b-form-group>
    </div>
    <div v-else-if="showType == 'properties'">
      <eoc-medications-v1-properties :formId="formId" />
    </div>
    <div
      v-if="showType == 'form-submitter' ||
          (showType == 'e-form' && properties.eFormEditable)"
      :style="properties.style"
      class="medication-table-container"      
      v-show="!computedHidden"
    >
      <b-form-group
        :description="
          superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'description',
            value: properties.description,
            defaultValue: '',
            form: this.form
          })
        "
        :style="properties.style"
      >
        <template v-slot:label="">
          <div class="d-flex align-items-center mb-3">
            <span style="font-size:16px;" class="mr-3">
              {{
                superComputeFormSubmitterValue({
                  elementId: id,
                  property: "label",
                  value: properties.label,
                  defaultValue: "",
                  form: form
                })
              }}
            </span>
          </div>
        </template>
        <fb-table-v1
          :showType="showType"
          :properties="tableProperties"
          :id="id"
          :form="form"
        ></fb-table-v1>
      </b-form-group>
    </div>
    <div
      v-if="showType == 'form-viewer'"
      :style="properties.style"
      class="medication-table-container"
    >
      <fb-table-v1
        :showType="showType"
        :properties="tableProperties"
        :id="id"
        :form="form"
      ></fb-table-v1>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import EocMedicationsV1Properties from "./EocMedicationsV1Properties.vue";
import marsServer from "../../../../server/marsRecord";
import { formatDate } from "../../../../helpers/date";
import { formatUser } from "../../../../helpers/user";
export default {
  name: "EocMedicationsV1",
  components: { EocMedicationsV1Properties },
  props: ["showType", "properties", "form", "id", "formId"],
  data() {
    return {
      computedProperties: ["description", "label", "hidden"],
      computedConditions: {},
      medicationRecords: []
    };
  },
  async mounted() {
    if (this.showType != "form-builder") {
      const medications = await await marsServer.query({
        episodeOfCareIds: [this.client.episodeOfCare.id],
        fromDate: null,
        toDate: null,
        medicationIds: [],
        status: [],
        page: 0,
        pageSize: 1000000,
        orderBy: "datetime",
        orderByDescending: false
      });
      this.medicationRecords = medications.records.map(medication => ({
        ...medication,
        dateTime: formatDate(medication.dateTime),
        type: medication.type.toUpperCase(),
        medicationLabel: `${medication.medication?.name}, ${medication.dosageAmount} ${medication.unitOfMeasurement?.name} by ${medication.medicationRoute?.name}`,
        givenBy: medication.givenBy ? formatUser(medication.givenBy) : "",
        signedBy: medication.signedBy ? formatUser(medication.signedBy) : ""
      }));
    }
    const preCode = `patient.episodeOfCare.medications = ${JSON.stringify(
      this.medicationRecords
    )};`;
    if (
      this.showType == "form-submitter" &&
      this.properties.value.includes("{{")
    ) {
      this.medicationRecords = this.superComputeFormSubmitterValue({
        elementId: this.id,
        property: "value",
        value: this.properties.value,
        defaultValue: "",
        form: this.form,
        preCode: preCode
      });
    }

    this.computeConditions();
  },
  methods: {
    ...mapMutations("formSubmitter", ["setFormSubmitterComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm[this.id]
        ? this.computedPropertiesForm[this.id][property]
          ? this.computedPropertiesForm[this.id][property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group is-table" id="__BVID__48">
        <legend style="font-size:16px;" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0" id="__BVID__48__BV_label_">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          <div>
            <div>
              <table role="table" aria-busy="false" aria-colcount="3" class="table b-table custom-fb-table mt-2 table-striped table-hover" id="__BVID__50">
                <thead role="rowgroup" class="">
                  <tr role="row" class="">
                    <th role="columnheader" scope="col" aria-colindex="1" class="">
                      <div>Date & Time</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="2" class="">
                      <div>Status</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="3">
                      <div>Type</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="4">
                      <div>Medication</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="5">
                      <div>Given By</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="5">
                      <div>Notes</div>
                    </th>
                     <th role="columnheader" scope="col" aria-colindex="5">
                      <div>Signed By</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="5">
                      <div>Signature</div>
                    </th>
                  </tr>
                </thead>
                <tbody role="rowgroup">
                ${(this.tableProperties.items || [])
                  .map(
                    item => `
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="" style="min-width: 130px;">${
                      item.dateTime
                    }</td>
                    <td aria-colindex="2" role="cell" class="" style="min-width: 130px;">${
                      item.status
                    }</td>
                    <td aria-colindex="3" role="cell" style="min-width: 130px;">${
                      item.type
                    }</td>
                    <td aria-colindex="3" role="cell" style="min-width: 130px;">${
                      item.medicationLabel
                    }</td>
                    <td aria-colindex="3" role="cell" style="min-width: 130px;">${
                      item.givenBy
                    }</td>
                    <td aria-colindex="3" role="cell" style="min-width: 130px;">${
                      item.notes ? item.notes : ""
                    }</td>
                    <td aria-colindex="3" role="cell" style="min-width: 100px;">${
                      item.signedBy
                    }</td>
                    <td aria-colindex="3" role="cell" style="min-width: 100px;">${
                      item.signature ? `<img style="width: 100%;" src="${item.signature}" />` : ""
                    }</td>
                  </tr>
                `
                  )
                  .join("")}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue",
      "superComputeFormSubmitterValue",
      "computeFormSubmitterValue"
    ]),
    ...mapState("formSubmitter", {
      client: state => state.form.client
    }),
    ...mapState("formSubmitter", {
      computedPropertiesForm: state => {
        return state.form.computedProperties;
      }
    }),
    tableProperties() {
      let items = this.medicationRecords;
      return {
        ...this.properties,
        items: items,
        columns: [
          {
            key: "dateTime",
            label: "Date & Time"
          },
          {
            key: "status",
            label: "Status"
          },
          {
            key: "type",
            label: "Type"
          },
          {
            key: "medicationLabel",
            label: "Medication"
          },
          {
            key: "givenBy",
            label: "Given By"
          },
          {
            key: "notes",
            label: "Notes"
          },
          {
            key: "signedBy",
            label: "Signed By"
          },
          {
            key: "signature",
            label: "Signature"
          }
        ]
      };
    },
    computedHidden(){
      const hiddenValue = this.computedConditions.hidden
        ? this.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'hidden',
            value: this.properties.hidden,
            defaultValue: false,
            form: this.form
          })
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>

<style scoped>
.medication-table-container >>> td {
  min-width: 130px;
}
</style>
